import { API_BASE_URL } from './request.js';

/**
 * 后端相对路径 → API 域名 + 路径（已是 http(s) 则原样返回）
 */
export function resolveMediaUrl(path) {
	if (path == null || path === '') return '';
	const raw = String(path).trim();
	if (!raw) return '';
	if (/^https?:\/\//i.test(raw) || raw.indexOf('data:') === 0 || raw.indexOf('blob:') === 0) {
		return raw;
	}
	const base = String(API_BASE_URL || '').replace(/\/+$/, '');
	const rel = raw.charAt(0) === '/' ? raw : '/' + raw;
	return base + rel;
}

/**
 * 富文本里相对 src 的图片也拼上 API 域名
 */
export function rewriteHtmlMediaUrls(html) {
	if (!html || typeof html !== 'string') return html || '';
	return html.replace(
		/(<img\b[^>]*?\bsrc\s*=\s*)(["'])(?!https?:\/\/|data:|blob:)([^"']+)\2/gi,
		(match, prefix, quote, src) => prefix + quote + resolveMediaUrl(src) + quote
	);
}
